<template>
    <div class="real-estate-card col-12 col-md-6 col-lg-4 mb-2" :style="{ opacity: realEstate.active ? 1 : 0.5 }">
        <div class="card">
            <div class="card-body pb-1">

                <div class="real-estate-image-container">
                    <qrcode :value="realEstate.url" :size="150" v-if="showQrCode"></qrcode>
                    <img class="real-estate-image" :src="realEstate.image" @error="imageLoadFailed = true" v-else-if="realEstate.image && !imageLoadFailed">
                </div>

                <div class="mb-1">
                    <button type="button" class="btn w-100" :class="`btn-${realEstate.active ? 'success' : 'danger'}`" @click="realEstate.active = !realEstate.active">
                        <i class="fas" :class="`fa-${realEstate.active ? 'check' : 'times'}`"></i>
                        Összehasonlításban {{ realEstate.active ? 'részt vesz' : 'nem vesz részt' }}
                    </button>
                </div>

                <div class="input-group mb-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Link:</span>
                    </div>
                    <input class="real-estate-url-input form-control" type="text" readonly :value="realEstate.url.replace('https://', '')" @click="openRealEstateUrl" title="Megnyitás új lapon">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-secondary" :title="`QR kód ${showQrCode ? 'elrejtése' : 'megnyitása'}`" @click="showQrCode = !showQrCode"><i class="fas fa-qrcode"></i></button>
                    </div>
                </div>

                <div class="input-group mb-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Alapterület:</span>
                    </div>
                    <input class="form-control" type="text" readonly :value="`${realEstate.area} nm`">
                </div>

                <div class="input-group mb-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Ár:</span>
                    </div>
                    <input class="form-control" type="text" readonly :value="formatPrice(realEstate.price)">
                </div>

                <div class="input-group mb-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Négyzetméter ár:</span>
                    </div>
                    <input class="form-control" type="text" readonly :value="formatPrice(Math.round(realEstate.areaPrice))">
                </div>

                <div class="input-group mb-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Átl. nm ár eltérés:</span>
                    </div>
                    <input class="form-control" type="text" readonly :value="`${avgAreaPriceDiff >= 0 ? '+' : ''}${Math.round(avgAreaPriceDiff * 1000) / 10}%`" :class="avgAreaPriceInputClass">
                </div>

                <div class="input-group mb-1" v-for="correction in realEstate.corrections">
                    <div class="input-group-prepend">
                        <span class="input-group-text">{{ correction.name }}:</span>
                    </div>
                    <select class="form-control" v-model="correction.value" :class="correction.value > 0 ? 'outline-success' : (correction.value < 0 ? 'outline-danger' : '')">
                        <option :value="value" v-for="value in generateRange(-optionInterval, optionInterval, true)"><template v-if="value > 0">+</template>{{ value }}</option>
                    </select>
                </div>

                <div class="input-group mb-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Korrekciós érték:</span>
                    </div>
                    <input class="form-control" type="text" readonly :value="`${calculatedCorrectionValue > 0 ? '+' : ''}${Math.round(calculatedCorrectionValue * 1000) / 1000}`" :class="calculatedCorrectionValue > 0 ? 'outline-success' : (calculatedCorrectionValue < 0 ? 'outline-danger' : '')">
                </div>

                <div class="real-estate-source">Forrás: {{ realEstate.src }}</div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RealEstateCard",
    data: function () {
        return {
            showQrCode: false,
            imageLoadFailed: false,
        };
    },
    props: {
        realEstate: { type: Object },
        optionInterval: { type: Number },
        avgAreaPrice: { type: Number },
    },
    computed: {
        calculatedCorrectionValue: function () {
            return this.realEstate.calculateCorrectionValue();
        },
        avgAreaPriceDiff: function () {
            return (this.realEstate.areaPrice - this.avgAreaPrice) / this.avgAreaPrice;
        },
        avgAreaPriceInputClass: function () {
            let avgAreaPriceDiff = Math.abs(this.avgAreaPriceDiff);
            if (avgAreaPriceDiff >= 0.3) return 'outline-danger';
            if (avgAreaPriceDiff >= 0.2) return 'outline-warning';
            return null;
        },
    },
    methods: {
        openRealEstateUrl: function () {
            window.open(this.realEstate.url);
        },
    },
}
</script>
